export default __webpack_public_path__ + "static/media/strategic2.cffe0134.png";